import { render, staticRenderFns } from "./InfraPXDashboard.vue?vue&type=template&id=74c04fbe&"
import script from "./InfraPXDashboard.vue?vue&type=script&lang=js&"
export * from "./InfraPXDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports